import React, { useEffect, useState, useContext } from "react";
import Input from "../../material/input/Input";
import Select from "../../material/select/Select";
import { HashLoader } from "react-spinners";
import * as publicApi from "../../../service/publicApi";
import * as userApi from "../../../service/userApi";
import * as regex from "../../../service/regex";
import moment from "moment/moment";
import "moment/locale/th";
import PageHeader from "../../pageheader/PageHeader";
import MenuAdmin from "../navAdmin/Menu";
import styles from "./ManageInfo.module.css";

import { CurrentUserContext } from "../../../App";
import CheckBoxV3 from "../../material/checkboxV3/CheckBoxV3";
import HeadBar from "../../public/headBar/HeadBar";
import Breadcrumb from "../../public/breacrumb/breadcrumb";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowDown } from "@fortawesome/free-solid-svg-icons";
import Datepicker from "../../material/datepicker/Datepicker";

function ManageInfo({ role }) {
  const { setIsMessage } = useContext(CurrentUserContext);

  const [loading, setLoading] = useState(true);
  const [getImgDefault, setGetImgDefault] = useState(null);
  const [showImageList, setShowImageList] = useState([]);
  const [pname, setPname] = useState("");
  const [pid, setPid] = useState("");
  const [fname, setFname] = useState("");
  const [lname, setLname] = useState("");
  const [address, setAddress] = useState("");
  const [postCode, setPostCode] = useState("");
  const [gender, setGender] = useState("");
  const [birthday, setBirthday] = useState("");

  const [road, setRoad] = useState(null);
  const [building, setBuilding] = useState(null);
  const [alley, setAlley] = useState("");
  const [provinceId, setProvinceId] = useState("");
  const [districtId, setDistrictId] = useState("");
  const [subDistrictId, setSubDistrictId] = useState("");

  const [provinceList, setProvinceList] = useState([]);
  const [districtList, setDistrictList] = useState([]);
  const [subDistrictList, setSubDistrictList] = useState([]);
  const [disablePname, setDisablePname] = useState(false);
  const [disableFname, setDisableFname] = useState(false);
  const [disableLname, setDisableLname] = useState(false);
  const [disablePid, setDisablePid] = useState(false);

  const [moo, setMoo] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  // const [showCard1, setShowCard1] = useState(false)
  const [personalInformation, setPersonalInformation] = useState(false);
  const [permissionEmail, setPermissionEmail] = useState(false);

  // const [showCard2, setShowCard2] = useState(false)
  const [consentForm, setConsentForm] = useState(false);

  const pathItems = [
    { name: "หน้าหลัก", url: `/` },
    { name: "จัดการข้อมูลส่วนตัว", url: `${role ?? ""}/manageinfo` },
  ];
  let genderList = [
    {
      key: "male",
      value: "ชาย",
    },
    {
      key: "female",
      value: "หญิง",
    },
  ];
  let pnameList = [
    {
      key: "นาย",
      value: "นาย",
    },
    {
      key: "นาง",
      value: "นาง",
    },
    {
      key: "นางสาว",
      value: "นางสาว",
    },
  ];

  const PreSetaTialwind = {
    HeadInput: "mb-3 text-sm text-[#A2B5BC]",
    FieldInput: "w-full flex justify-self-center",
  };

  useEffect(() => {
    getDataUser();
  }, []);

  useEffect(() => {
    getProvinceList();
  }, [provinceId]);

  const getDataUser = async () => {
    setLoading(true);
    let res = await userApi.data();
    // console.log(res)
    setLoading(false);
    if (res) {
      if (res["data"]["code"] === 200) {
        setPname(res["data"]["user_data"]["pname"]);
        setFname(res["data"]["user_data"]["fname"]);
        setLname(res["data"]["user_data"]["lname"]);
        setPid(res["data"]["user_data"]["pid"]);
        setGender(res["data"]["user_data"]["gender"]);
        setBirthday(res["data"]["user_data"]["birthday"]);
        // setBirthday(moment(res['data']['user_data']['birthday']).add(543, 'years').format('DD MMMM YYYY'))
        setAddress(res["data"]["user_data"]["current_address"]["address"]);
        setMoo(res["data"]["user_data"]["current_address"]["village_number"]);
        setRoad(res["data"]["user_data"]["current_address"]["road"]);
        setBuilding(res["data"]["user_data"]["current_address"]["building"]);
        setAlley(res["data"]["user_data"]["current_address"]["alley"]);
        setPostCode(res["data"]["user_data"]["current_address"]["post_code"]);
        setProvinceId(
          res["data"]["user_data"]["current_address"]["province_id"],
        );
        getDistrictList(
          res["data"]["user_data"]["current_address"]["province_id"],
        );
        setDistrictId(
          res["data"]["user_data"]["current_address"]["district_id"],
        );
        getSubDistrictList(
          res["data"]["user_data"]["current_address"]["district_id"],
        );
        setSubDistrictId(
          res["data"]["user_data"]["current_address"]["sub_district_id"],
        );
        setEmail(res["data"]["user_data"]["email"]);
        setPhoneNumber(res["data"]["user_data"]["phone_number"]);
        setPersonalInformation(
          res["data"]["user_data"]["permission"]["policy_personal_information"],
        );
        setConsentForm(res["data"]["user_data"]["permission"]["consent_form"]);
        setPermissionEmail(
          res["data"]["user_data"]["permission"]["access_to_email"],
        );

        localStorage.setItem("user", JSON.stringify(res["data"]["user_data"]));

        const currentOrigin = window.location.origin;
        const getBaseUrl = currentOrigin.includes('dmsc.moph.go.th') 
          ? currentOrigin 
          : 'https://dmsc-static.devfunction.com';
        const imageSrc = res["data"]["user_data"]?.["profile_image"] 
          && `${getBaseUrl}/image/${res["data"]["user_data"]?.["profile_image"]}`;
        setGetImgDefault(`${imageSrc}`);
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  const updateProfileData = async (
    phone_number,
    email,
    current_address,
    permission,
  ) => {
    // console.log(permission);
    let res = "";
    setLoading(true);
    res = await userApi.updateProfileData(
      phone_number,
      email,
      current_address,
      permission,
    );
    setLoading(false);
    if (res) {
      if (res["data"]["code"] === 200) {
        setIsMessage({
          type: "success",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  const updateProfileImage = async (targetfiles) => {
    let formData = new FormData();
    formData.append("image", targetfiles[0]);
    let res = "";
    setLoading(true);
    res = await userApi.updateProfileImage(formData);
    setLoading(false);
    if (res) {
      if (res["data"]["code"] === 200) {
        setIsMessage({
          type: "success",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
        getDataUser();
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  const getProvinceList = async () => {
    setLoading(true);
    let res = await publicApi.getProvinceList();
    setLoading(false);
    if (res) {
      if (res["data"]["code"] === 200) {
        setProvinceList(
          res["data"]["province_list"].map((item) => {
            return {
              key: item["province_id"],
              value: item["province_name"],
            };
          }),
        );
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  const getDistrictList = async (id) => {
    setLoading(true);
    let res = await publicApi.getDistrictList(id);
    setLoading(false);
    if (res) {
      if (res["data"]["code"] === 200) {
        setDistrictList(
          res["data"]["district_list"].map((item) => {
            return {
              key: item["district_id"],
              value: item["district_name"],
            };
          }),
        );
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  const getSubDistrictList = async (id) => {
    setLoading(true);
    let res = await publicApi.getSubDistrictList(id);
    setLoading(false);
    if (res) {
      if (res["data"]["code"] === 200) {
        setSubDistrictList(
          res["data"]["sub_district_list"].map((item) => {
            return {
              key: item["sub_district_id"],
              value: item["sub_district_name"],
            };
          }),
        );
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  const onSelectFile = (e) => {
    if (e !== "") {
      // console.log(e.target.files)
      const uploadFiles = e.target.files;
      createUrlBlobFile(uploadFiles);
      updateProfileImage(uploadFiles);
    }
  };

  const createUrlBlobFile = (uploadFiles) => {
    const uploadFilesImageList = Array.from(uploadFiles);

    const imageData = uploadFilesImageList.map((file) => {
      return {
        name: file["name"],
        url: URL.createObjectURL(file),
      };
    });
    setShowImageList(imageData);
  };

  const submitButtonClick = () => {
    if (!pname) {
      setIsMessage({ type: "warning", data: "กรุณาเลือกคำนำหน้า" });
      return;
    }
    if (!address) {
      setIsMessage({ type: "warning", data: "กรุณากรอกที่อยู่" });
      return;
    }
    if (!moo) {
      setIsMessage({ type: "warning", data: "กรุณากรอกหมู่" });
      return;
    }
    if (!postCode) {
      setIsMessage({ type: "warning", data: "กรุณากรอกรหัสไปรษณีย์" });
      return;
    }
    if (!provinceId) {
      setIsMessage({ type: "warning", data: "กรุณาเลือกจังหวัด" });
      return;
    }
    if (!districtId) {
      setIsMessage({ type: "warning", data: "กรุณาเลือกอำเภอ" });
      return;
    }
    if (!subDistrictId) {
      setIsMessage({ type: "warning", data: "กรุณาเลือกตำบล" });
      return;
    }
    if (!phoneNumber) {
      setIsMessage({ type: "warning", data: "กรุณากรอกเบอร์โทร" });
      return;
    }
    if (!email) {
      setIsMessage({ type: "warning", data: "กรุณากรอก Email" });
      return;
    }
    if (!consentForm || !personalInformation) {
      setIsMessage({ type: "warning", data: "กรุณา ยินยอมให้เข้าถึงข้อมูล" });
      return;
    } else {
      let current_address = {
        address: address,
        building: building,
        village_number: moo,
        alley: "-",
        road: road ?? "-",
        sub_district_id: subDistrictId,
        district_id: districtId,
        province_id: provinceId,
        post_code: postCode,
      };
      let permission = {
        access_data_every_time: false,
        access_data_some_time: false,
        consent_form: consentForm,
        policy_personal_information: personalInformation,
        access_to_email: permissionEmail,
      };
      updateProfileData(phoneNumber, email, current_address, permission);
    }
  };

  // return (
  //     <div className='global-page'>
  //         <MenuAdmin />
  //         <HashLoader disabled loading={loading} style={{ display: 'flex', justifyContent: 'center' }} color="#FF9768" />
  //         <PageHeader titlename={'จัดการข้อมูลส่วนตัว'} btnBackWard backpath={'/usermanagement'} />

  //         <div className='flex justify-center'>
  //             <div className='flex lg:flex-col w-full'>
  //                 <div className='flex flex-col lg:items-center lg:mr-0 mr-10'>
  //                     {showImageList.length > 0 ? <>
  //                         {showImageList.map((i, idx) => {
  //                             return (
  //                                 <img key={idx} className='drop-shadow-lg md:w-[220px] md:h-[160px] w-[280px] rounded-2xl h-[200px] md:mb-2 mb-10' src={i['url']} style={{ objectFit: 'contain' }} alt="" />
  //                             )
  //                         })}
  //                     </> : <>
  //                         {getImgDefault ? <>
  //                             <img className='drop-shadow-lg w-[280px] h-[200px] md:w-[220px] md:h-[160px] md:mb-2 mb-10 rounded-2xl' src={getImgDefault} style={{ objectFit: 'contain' }} alt="" />
  //                         </> : <img className='drop-shadow-lg w-56 h-56 md:w-40 md:h-40' src={require('../../../asset/image/image-user.svg').default} alt="" />
  //                         }
  //                     </>
  //                     }
  //                     <section>
  //                         <label>
  //                             <div className='md:text-[12px] md:h-[30px] md:w-[120px] flex justify-center items-center h-10 rounded-full bg-[#B9DFC5] text-[#000000] hover:ring-2 ring-[#B9DFC5] active:scale-90 transition-all duration-100 ease-in-out shadow-md md:mb-2 mb-8 w-[200px]'>อัปโหลดรูปภาพ</div>
  //                             <input
  //                                 type="file"
  //                                 accept="image/png ,image/jpeg"
  //                                 name='images'
  //                                 style={{ display: 'none' }}
  //                                 onChange={(e) => { onSelectFile(e) }} />
  //                         </label>
  //                     </section>

  //                 </div>
  //                 <div className={styles.size}>
  //                     <p className='pb-2 border-b border-[#B9DFBA] font-semibold mb-6 mt-5'>ข้อมูลส่วนตัว</p>
  //                     <div className={styles.align}>
  //                         <Input disabled placeholder="คำนำหน้า" value={pname} setValue={setPname}></Input>
  //                         <Input disabled placeholder="ชื่อ" value={fname} setValue={setFname}></Input>
  //                         <Input disabled placeholder="นามสกุล" value={lname} setValue={setLname}></Input>
  //                         <Input disabled placeholder="เลขบัตรประจำตัวประชาชน" value={pid} setValue={setPid}></Input>
  //                         <Input disabled placeholder="วัน เดือน ปีเกิด" value={birthday} setValue={setBirthday}></Input>
  //                     </div>
  //                     <p className='pb-2 border-b border-[#B9DFBA] font-semibold mb-6 mt-5'>ที่อยู่ปัจจุบัน</p>
  //                     <div className={styles.align}>
  //                         <Input placeholder="บ้านเลขที่" value={address} setValue={setAddress}></Input>
  //                         <Input placeholder="หมู่" value={moo} setValue={setMoo}></Input>
  //                         <Input placeholder="รหัสไปรษณีย์" value={postCode} setValue={setPostCode}></Input>
  //                         <div>
  //                             <Select placeholder="จังหวัด" value={provinceId} setValue={(e) => {
  //                                 setProvinceId(e)
  //                                 setDistrictId('')
  //                                 setDistrictList([])
  //                                 setSubDistrictId('')
  //                                 setSubDistrictList([])
  //                                 getDistrictList(e)
  //                             }} list={provinceList}></Select>
  //                         </div>
  //                         <div>
  //                             <Select placeholder="อำเภอ" value={districtId} setValue={(e) => {
  //                                 setDistrictId(e)
  //                                 setSubDistrictId('')
  //                                 setSubDistrictList([])
  //                                 getSubDistrictList(e)
  //                             }} list={districtList}></Select>
  //                         </div>
  //                         <div>
  //                             <Select placeholder="ตำบล" value={subDistrictId} setValue={setSubDistrictId} list={subDistrictList}></Select>
  //                         </div>
  //                     </div>
  //                     <p className='pb-2 border-b border-[#B9DFBA] font-semibold mb-6 mt-5'>ข้อมูลติดต่อ</p>
  //                     <div className={styles.align}>
  //                         <Input label='Email (ถ้ามี)' placeholder="E-mail" value={email} setValue={setEmail}></Input>
  //                         <Input placeholder="โทรศัพท์" value={phoneNumber} setValue={setPhoneNumber}></Input>
  //                     </div>
  //                     <div className='flex justify-center md:mt-5 mt-12 w-full'>
  //                         <button onClick={submitButtonClick} className='h-12 w-64 rounded-full bg-[#B9DFC5] md:text-[12px] md:h-[30px] md:w-[120px] text-[#000000] hover:ring-2 ring-[#B9DFC5] active:scale-90 transition-all duration-100 ease-in-out shadow-md'><p>บันทึกการแก้ไข</p></button>
  //                     </div>
  //                 </div>
  //             </div>
  //         </div>
  //     </div>
  // )

  return (
    <div className="global-page">
      <Breadcrumb pathItems={pathItems} />
      <div className="flex flex-col gap-2 items-center w-full pb-5 mt-[50px]">
        <h1 className="md:text-2xl flex text-3xl font-bold">
          จัดการข้อมูลส่วนตัว
        </h1>
        <span className="sm:text-lg flex text-xl font-bold">
          กรุณากรอกข้อมูลให้ครบถ้วน
        </span>
        <span className="sm:text-sm sm:font-normal flex text-lg font-bold">
          เพิ่มข้อมูลที่อยู่และตั้งค่าบัญชีเพื่อเข้าใช้งานในครั้งถัดไป
        </span>
      </div>
      <div className="2sm:flex-col flex flex-row gap-6 w-full">
        <div className="2sm:w-full flex flex-col gap-2 items-center w-[20%] max-h-[380px] text-nowrap">
          <div className="overflow-hidden aspect-square rounded-md">
            {showImageList.length > 0 ? (
              <>
                {showImageList.map((i, idx) => {
                  return <img key={idx} src={i["url"]} alt="" />;
                })}
              </>
            ) : (
              <>
                {getImgDefault ? (
                  <>
                    <img src={getImgDefault} alt="" />
                  </>
                ) : (
                  <img
                    className="aspect-square object-cover"
                    src={require("../../../asset/image/image-user.svg").default}
                    alt=""
                  />
                )}
              </>
            )}
          </div>
          <section>
            <label className="lg:text-xs flex flex-row justify-center items-center gap-2 w-full px-6 py-2 rounded-md text-white text-base bg-[#4F9C9D] cursor-pointer">
              <FontAwesomeIcon icon={faArrowDown} />
              <span>อัปโหลดไฟล์</span>
              <input
                type="file"
                accept="image/png ,image/jpeg"
                name="images"
                style={{ display: "none" }}
                onChange={(e) => {
                  onSelectFile(e);
                }}
              />
            </label>
          </section>
          <div className="lg:text-xs flex flex-col gap-1 justify-center items-center w-full text-base">
            <span>อัปโหลดไฟล์</span>
            <span>สกุล jpg, png</span>
            <span>ขนาดไฟล์ไม่เกิน 10 MB</span>
          </div>
        </div>
        <div className="2sm:w-full flex flex-col gap-4 w-[70%] h-full">
          <div className="flex flex-col gap-1 py-2 w-full">
            <span className="lg:text-base text-xl font-bold">
              ข้อมูลส่วนตัว
            </span>
            <div className="sm:flex sm:flex-col grid grid-flow-dense grid-cols-2 gap-5 justify-between w-full pb-2">
              <div className="w-full">
                <Select
                  disabled
                  value={pname}
                  setValue={setPname}
                  list={pnameList}
                  placeholder="เลือกคำนำหน้า"
                ></Select>
              </div>
              <div className="w-full"></div>
              <div className="w-full">
                <Input
                  disabled
                  label="ชื่อ"
                  placeholder="ชื่อ"
                  value={fname}
                  setValue={setFname}
                ></Input>
              </div>
              <div className="w-full">
                <Input
                  disabled
                  label="นามสกุล"
                  placeholder="นามสกุล"
                  value={lname}
                  setValue={setLname}
                ></Input>
              </div>
              <div className="w-full">
                <Input
                  regex={regex.pid()}
                  disabled
                  label="เลขบัตรประจำตัวประชาชน (กรอกตัวเลขไม่ต้องใส่ขีด)"
                  placeholder="เลขบัตรประจำตัวประชาชน (กรอกตัวเลขไม่ต้องใส่ขีด)"
                  value={pid}
                  setValue={setPid}
                ></Input>
              </div>
              <div className="w-full">
                <Select
                  placeholder="เพศ"
                  disabled
                  value={gender}
                  setValue={setGender}
                  list={genderList}
                ></Select>
              </div>
              <div className="w-full">
                {/* <Datepicker label="วันเกิด" value={birthday} setValue={setBirthday}></Datepicker> */}
                <Input
                  regex={regex.pid()}
                  label="วันเกิด"
                  disabled
                  placeholder="วันเกิด"
                  value={birthday}
                ></Input>
              </div>
            </div>
          </div>
          <div className="flex flex-col gap-2 py-2 w-full">
            <span className="lg:text-base text-xl font-bold">
              ที่อยู่ปัจจุบัน
            </span>
            <div className="sm:flex sm:flex-col grid grid-flow-dense grid-cols-2 gap-5 justify-between w-full pb-2">
              <div className="w-full">
                <Input
                  disabled={disableLname}
                  placeholder="บ้านเลขที่"
                  label="บ้านเลขที่"
                  value={address}
                  setValue={setAddress}
                ></Input>
              </div>
              <div className="w-full">
                <Input
                  disabled={disableLname}
                  placeholder="อาคาร/ตึก/ชั้น"
                  label="อาคาร/ตึก/ชั้น"
                  value={building}
                  setValue={setBuilding}
                ></Input>
              </div>
              <div className="w-full">
                <Input
                  disabled={disableLname}
                  placeholder="หมู่"
                  label="หมู่"
                  value={moo}
                  setValue={setMoo}
                ></Input>
              </div>
              {/* <div className="w-full">
                                <Input disabled={disableLname} placeholder="ตรอก/ซอย" value={alley} setValue={setAlley}></Input>
                            </div>
                            <div className="w-full">
                                <Input disabled={disableLname} placeholder="ถนน" value={road} setValue={setRoad}></Input>
                            </div> */}
              <div className="w-full">
                <Select
                  label="จังหวัด"
                  placeholder="จังหวัด"
                  value={provinceId}
                  setValue={(e) => {
                    setProvinceId(e);
                    setDistrictId("");
                    setDistrictList([]);
                    setSubDistrictId("");
                    setSubDistrictList([]);
                    getDistrictList(e);
                  }}
                  list={provinceList}
                ></Select>
              </div>
              <div className="w-full">
                <Select
                  label="อำเภอ"
                  placeholder="อำเภอ"
                  value={districtId}
                  setValue={(e) => {
                    setDistrictId(e);
                    setSubDistrictId("");
                    setSubDistrictList([]);
                    getSubDistrictList(e);
                  }}
                  list={districtList}
                ></Select>
              </div>
              <div className="w-full">
                <Select
                  label="ตำบล"
                  placeholder="ตำบล"
                  value={subDistrictId}
                  setValue={setSubDistrictId}
                  list={subDistrictList}
                ></Select>
              </div>
              <div className="w-full">
                <Input
                  disabled={disableLname}
                  label="รหัสไปรษณีย์"
                  placeholder="รหัสไปรษณีย์"
                  value={postCode}
                  setValue={setPostCode}
                ></Input>
              </div>
            </div>
          </div>
          <div className="flex flex-col gap-1 py-2 w-full">
            <span className="lg:text-base text-xl font-bold">ข้อมูลติดต่อ</span>
            <div className="sm:flex sm:flex-col grid grid-flow-dense grid-cols-2 gap-5 justify-between w-full pb-2">
              <div className="w-full">
                <Input
                  disabled={disableLname}
                  placeholder="หมายเลขโทรศัพท์"
                  label="หมายเลขโทรศัพท์"
                  value={phoneNumber}
                  setValue={setPhoneNumber}
                ></Input>
              </div>
              <div className="w-full">
                <Input
                  disabled={disableLname}
                  placeholder="อีเมล"
                  label="อีเมล"
                  value={email}
                  setValue={setEmail}
                ></Input>
              </div>
            </div>
          </div>
          <div className="mt-[1rem]">
            <span className="lg:text-base text-xl font-bold">
              ยินยอมการเข้าถึงแจ้งเตือนผ่าน Email
            </span>
          </div>
          <CheckBoxV3
            id="checkbox3"
            value={permissionEmail}
            setValue={setPermissionEmail}
            label="ยินยอมการเข้าสู่ระบบผ่าน Email"
          />
          <div className="mt-[1rem]">
            <span className="lg:text-base text-xl font-bold">
              ยินยอมอนุญาตการเปิดเผยและเข้าถึงข้อมูล
            </span>
          </div>
          <CheckBoxV3
            id="checkbox1"
            value={personalInformation}
            setValue={setPersonalInformation}
            label='การยินยอมให้แลกเปลี่ยนข้อมูลกับระเบียนสุขภาพส่วนบุคคลที่เชื่อมต่อกับระบบ "ผูกพันธ์ุ"'
          />
          <CheckBoxV3
            id="checkbox2"
            value={consentForm}
            setValue={setConsentForm}
            label="ยินยอมในการให้ข้อมูลการตรวจทางพันธุกรรมที่มาจากระบบสารสนเทศของโรงพยาบาล การตรวจจากห้องปฏิบัติการกรมวิทยาศาสตร์การแพทย์ และระบบอื่น ๆ สามารถใช้แลกเปลี่ยนและจัดเก็บในระบผูกพันธุ์ได้"
          />
        </div>
      </div>
      <div className="flex justify-center mt-12 w-full">
        <button
          onClick={submitButtonClick}
          className="h-12 w-64 bg-blue-500 text-white rounded-md shadow-md cursor-pointer md:w-[140px] md:text-[12px] md:h-8"
        >
          <p>บันทึก</p>
        </button>
      </div>
    </div>
  );
}

export default ManageInfo;
